import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { ArrowLeft, Mail, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

const ContactPage = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = React.useState(false);
  const email = 'contact@meandmypandas.com';

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    toast.success('Email copied to clipboard!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 to-blue-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <Button 
          onClick={() => navigate(-1)} 
          variant="ghost" 
          className="mb-6 text-primary hover:text-primary/80"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back
        </Button>

        <Card className="bg-white rounded-2xl border border-stone-100 shadow-sm p-8">
          <div className="text-center space-y-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
              <Mail className="w-8 h-8 text-primary" />
            </div>
            
            <div>
              <h1 className="text-3xl font-nunito font-bold text-[#2D2D2D] mb-2">
                Contact Us
              </h1>
              <p className="text-[#57534E]">
                Have questions or feedback? We'd love to hear from you!
              </p>
            </div>

            <div className="bg-stone-50 rounded-xl p-6 space-y-4">
              <p className="text-sm text-[#57534E]">Send us an email at:</p>
              <div className="flex items-center justify-center gap-3">
                <span className="text-xl font-semibold text-primary">
                  {email}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleCopyEmail}
                  className="border-primary text-primary hover:bg-primary/10"
                >
                  {copied ? (
                    <Check className="w-4 h-4" />
                  ) : (
                    <Copy className="w-4 h-4" />
                  )}
                </Button>
              </div>
            </div>

            <p className="text-sm text-[#A8A29E]">
              We typically respond within 24-48 hours.
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ContactPage;
